import React from 'react';

const DataFrameTable = (props) => {
  // Parse the data if it is a JSON string; otherwise, use it directly
  const data = props.data
  const tableData = typeof data === 'string' ? JSON.parse(data) : data;

  if (tableData.length === 0) return <p>No data to display</p>;

  // Get the headers from the keys of the first object
  const headers = Object.keys(tableData[0]);

  return (
    <table>
      <thead>
        <tr>
          {headers.map((header) => (
            <th key={header}>{header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {tableData.map((row, index) => (
          <tr key={index}>
            {headers.map((header) => (
              <td key={header}>{row[header]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default DataFrameTable;